import React from 'react';
function SchoolStats() {  return (
    <section className="stats-band" style={{ padding: "0" }}>
      <div className="wrap" style={{ paddingTop: "72px", paddingBottom: "72px" }}>
        <div className="stats-grid reveal">
          <div>
            <div className="stat-big">{"300+"}</div>
            <div className="stat-cap">{"Students Enrolled"}</div>
          </div>
          <div>
            <div className="stat-big">{"20+"}</div>
            <div className="stat-cap">{"Expert Faculty"}</div>
          </div>
          <div>
            <div className="stat-big">{"25+"}</div>
            <div className="stat-cap">{"Years of Excellence"}</div>
          </div>
         
        </div>
      </div>
    </section>
  );
}

export default SchoolStats;
